module.exports = __webpack_public_path__ + "img/icon_kefu.27f6ed4b.png";